<template>
    <div class="extended-panel activity-panel poi-manager-panel routed-extended-page">
        <poi-manager-panel class="side-panel-fill" @toggleUtilityPanel="goBack" />
    </div>
</template>

<script>
import PoiManagerPanel from '@/components/panels/PoiManagerPanel.vue'

export default {
    name: 'PoiManagementPage',
    components: { PoiManagerPanel },
    methods: {
        goBack() {
            this.$router.push({ name: 'geofleet.index' })
        }
    }
}
</script>
